import React from 'react';
import { CircularProgress, Box } from '@mui/material';

/**
 * LoadingSpinner - A presentational component for displaying loading state
 * 
 * @param {Object} props
 * @param {string} props.size - Size of the spinner: 'small', 'medium', or 'large'
 */
const LoadingSpinner = ({ size = 'medium' }) => {
  const sizeMap = {
    small: 24,
    medium: 40,
    large: 60
  };

  const spinnerSize = sizeMap[size] || sizeMap.medium;

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 2
      }}
    >
      <CircularProgress size={spinnerSize} aria-label="Loading" />
    </Box>
  );
};

export default LoadingSpinner;
